import React from 'react';
import { TextInputArea } from '@uhg-abyss/web/ui/TextInputArea';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useForm } from '@uhg-abyss/web/hooks/useForm';

const CharacterCount = styled('label', {
  fontWeight: 15,
  verticalAlign: 'bottom',
  fontSize: '12px',
  color: '$gray6',
  marginLeft: '1em',
  display: 'inline-block',
});

export const NpiNumbers = () => {
  const form = useForm();

  const validNpi = (value) => {
    if (value.length < 11000) {
      if (value.match(/[^\w,]/)) {
        return false;
      }
      const npiArray = value.split(',');
      if (
        npiArray.every((npi) => {
          return npi.length === 10;
        })
      ) {
        return true;
      }
      return false;
    }
    return false;
  };

  const npiInfo = form.getValues('practiceInformation.npiInformation');
  const stateVal = form.getValues('practiceInformation.medLicense[0].state');
  const npiErrorValues =
    npiInfo &&
    npiInfo
      .split(',')
      .filter((value) => {
        return value.length !== 10;
      })
      .map((value) => {
        return value;
      });
  const INVALID_NPIS = npiErrorValues && npiErrorValues.toString();

  const handleOnPaste = (e) => {
    const clipboard = e.clipboardData || window.clipboardData;
    let copyValue = clipboard.getData && clipboard.getData('Text');
    if (!copyValue.match(/[,]/g) && copyValue.match(/[\n]/g)) {
      copyValue = copyValue.replace(/[\s]/g, ',');
    }
    if (copyValue.includes(',,')) {
      copyValue = copyValue.replace(/,,/g, ',');
    }
    copyValue = copyValue.replace(
      /[!@#$%^&*)(\s{}<>.[\]\-+_`~=\\|';":/?]/g,
      ''
    );
    form.setValue('practiceInformation.npiInformation', copyValue);
  };

  return (
    <React.Fragment>
      <TextInputArea
        id="npiInfoField"
        helper="Provide NPI(s) for all individuals and groups/facilities
            who will submit UHC claims."
        label=" National Provider Identifier (NPI)"
        model="practiceInformation.npiInformation"
        aria-label="type here to add NPI's"
        subText="Enter your NPI(s) here. Each NPI must be 10 alphanumeric characters.
                Separate multiple NPIs with commas."
        rows={5}
        maxLength={700}
        onChange={() => {
          form.setValue('practiceInformation.medLicense[0].state', stateVal, {
            focused: false,
          });
        }}
        formatValue={(value) => {
          let updatedVal = '';
          updatedVal = value.replace(
            /[!@#$%^&*)({}<>.[\]\-+_`~=\\|';":/?]/g,
            ''
          );
          updatedVal = updatedVal.replace(/\s/g, ',').replace(/,,/g, ',');

          return updatedVal;
        }}
        validators={{
          validate: (value) => {
            if (value.length > 549) {
              return 'Max character limit has been reached.';
            }
            if (npiErrorValues.length > 0 && value.includes(',')) {
              return `Invalid NPI values entered: ${INVALID_NPIS}`;
            }
            if (value && !validNpi(value)) {
              return 'Information entered is in an invalid format.';
            }
            return null;
          },
        }}
        onPaste={handleOnPaste}
        autoComplete="off"
        descriptorsDisplay="column"
      />
      <CharacterCount>
        {npiInfo ? npiInfo.length : 0}/549 Characters
      </CharacterCount>
    </React.Fragment>
  );
};

NpiNumbers.propTypes = {};

NpiNumbers.defaultProps = {};
